import { useAppStore } from "@hooks/useAppStore";

export const useAppTemplate = () => {
	const template = useAppStore((state) => state.app.template);
	return {
		template,
		isLanguageLearningApp: template === "language-learning",
		isCmeApp: template === "cme",
	};
};
